
export const REACT_APP_ENV = process.env.REACT_APP_ENV as 'development';
const path_config = {
  development: {
    ROOT_PATH: 'https://api-ipp-dev.cpgroupcloud.com',
    DOMAIN: 'https://gsp-dev.cpgroupcloud.com/',
    WEBSOCKET: 'wss://api-ipp-dev.cpgroupcloud.com/websocket',
  },
  production: {
    ROOT_PATH: 'https://api-ipp-i.cpgroupcloud.com',
    DOMAIN: 'https://gsp-i.cpgroupcloud.com/',
    WEBSOCKET: 'wss://api-ipp-i.cpgroupcloud.com/websocket',
  },
  stg: {
    ROOT_PATH: 'https://api-ipp-stg.cpgroupcloud.com',
    DOMAIN: 'https://gsp-dev.cpgroupcloud.com/',
    WEBSOCKET: 'wss://api-ipp-dev.cpgroupcloud.com/websocket',
  }
};
export const DOMAIN = path_config[REACT_APP_ENV].DOMAIN;
export const ROOT_PATH = path_config[REACT_APP_ENV].ROOT_PATH;
export const WEBSOCKET = path_config[REACT_APP_ENV].WEBSOCKET;